import { AccordionButton, Box, Heading, Radio } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import PropTypes, { InferProps } from 'prop-types';

const HeaderProps = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};

export type HeaderPropsTypes = InferProps<typeof HeaderProps>;

const AccordionHeader = ({
  name,
  title,
  isExpanded,
  children,
}: HeaderPropsTypes) => (
  <AccordionButton className={cx('TabButton')}>
    <>
      <Box as="span" flex="1" textAlign="left">
        <Radio value={name} isChecked={isExpanded}>
          <Heading variant="h2">
            {title}
          </Heading>
        </Radio>
      </Box>
      {children}
    </>
  </AccordionButton>
);

AccordionHeader.propTypes = HeaderProps;

export { AccordionHeader };
